<template>
    <div v-bind="$attrs" class="mt-1">
        <label :for="name" class="block text-sm font-medium leading-5 text-gray-700">
            <span>{{ label }}</span>
            <transition
                enter-active-class="transition ease-out duration-100"
                enter-from-class="transform opacity-0 scale-95"
                enter-to-class="transform opacity-100 scale-100"
                leave-active-class="transition ease-in duration-75"
                leave-from-class="transform opacity-100 scale-100"
                leave-to-class="transform opacity-0 scale-95"
            >
                <svg
                    v-show="!show"
                    @click="show = true"
                    class="w-4 h-4 text-gray-600 inline"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                    ></path>
                </svg>
            </transition>
        </label>
        <div class="mt-1 rounded-md shadow-sm">
            <select
                :id="name"
                :required="required"
                :name="name"
                v-model="selected"
                class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            >
                <option v-if="nullOption" value="">
                    {{ $t('messages.select') }}
                </option>
                <option v-for="option in filteredOptions" :value="option[propertyValue]" :key="option[propertyValue]">
                    {{ option[propertyName] }}
                </option>
            </select>
        </div>
    </div>
</template>

<script>
export default {
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            required: false,
        },
        options: {
            required: true,
            type: Array,
        },
        preferences: {
            required: false,
            type: Array,
            default: () => [],
        },
        label: {
            required: true,
            type: String,
        },
        name: {
            required: true,
            type: String,
        },
        required: {
            required: false,
            type: Boolean,
            default: false,
        },
        nullOption: {
            required: false,
            type: Boolean,
            default: true,
        },
        defaultOption: {
            required: false,
            default: null,
        },
        propertyName: {
            required: false,
            type: String,
            default: 'name',
        },
        propertyValue: {
            required: false,
            type: String,
            default: 'id',
        },
        autoselect: {
            required: false,
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            show: false,
            selected: '',
        };
    },

    methods: {
        showAll() {
            this.show = true;
        },
    },

    computed: {
        filteredOptions: function () {
            if (this.preferences.length === 0) {
                return this.options;
            }

            if (this.show === true) {
                return this.options;
            }

            const filtered = this.options.filter(
                (o) => this.preferences.includes(o[this.propertyValue]) || o[this.propertyValue] == this.selected,
            );

            return filtered.length ? filtered : this.options;
        },
    },
    watch: {
        selected(newVal) {
            this.$emit('update:modelValue', newVal);
        },
        modelValue(newVal) {
            this.selected = newVal;
        },
    },
    mounted() {
        if (this.preferences.length === 0) {
            this.show = true;
        }

        if (this.preferences.length === 1 && this.autoselect) {
            this.selected = this.preferences[0];
        }

        if (this.defaultOption) {
            this.selected = this.defaultOption;
        }

        if (this.modelValue) {
            this.selected = this.modelValue;
        }
    },
};
</script>
